// useTableActions.js

import useTableModalActions from 'views/table/hooks/useTableModalActions';
import useTableModalState from 'views/table/hooks/useTableModalState';
import useTableFieldActions from 'views/table/hooks/useTableFieldActions';

const useTableActions = ({
    view,
    typeDef,
    nodes,
    visibleFieldKeys,
    hasExplicitProperties,
}) => {
    const {
        modalState,
        handleModalOpen,
        handleModalClose,
    } = useTableModalState();

    const {
        handleDateChange,
        handleEnumChange,
        handleTagsSaved,
        handleLocationSaved,
        handlePeopleSaved,
        handleNodelistSaved,
        handlePercentageChange,
    } = useTableModalActions({
        modalState,
        typeDefKey: typeDef?.key,
        typeDef,
    });

    const {
        fieldModalOpen,
        fieldSaving,
        handleFieldModalOpen,
        handleAddFieldClick,
        handleFieldSave,
    } = useTableFieldActions({
        view,
        typeDef,
        nodes,
        visibleFieldKeys,
        hasExplicitProperties,
    });

    return {
        modalState,
        handleModalOpen,
        handleModalClose,
        handleDateChange,
        handleEnumChange,
        handleTagsSaved,
        handleLocationSaved,
        handlePeopleSaved,
        handleNodelistSaved,
        handlePercentageChange,
        fieldModalOpen,
        fieldSaving,
        handleFieldModalOpen,
        handleAddFieldClick,
        handleFieldSave,
    };
};

export default useTableActions;
